<template>
  <section id="rush-academy" class="p-5">
    <h4> {{ title }} </h4>
    <b-row>
      <b-col lg="10">
        <p> {{ paragraph }} </p>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="4" class="mb-3 mb-md-0">
        <RushAcademyTutorialProgress
          @change-video="handleChangeVideo"
          :total_progress="rush_academy ? rush_academy.total_progress : 0"
          :courses="computedCourses" />
      </b-col>
      <b-col md="8">
        <component
          v-bind:is="currentComponent"
          @handle-playing-video="handlePlayingVideo"
          @change-video="handleChangeVideo"
          @handle-video-ended="handleVideoEnded"
          @reset-play-status="handleResetPlayStatus"
          @set-playing-progress="setPlayingProgress"
          :detail="currentVideoDetail"
          :courses="computedCourses">
        </component>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import RushAcademyTutorialProgress from "@/components/rush-academy/TutorialProgress";
import RushAcademyTutorialVideo from "@/components/rush-academy/TutorialVideo";
import { getIdFromUrl } from "vue-youtube";
import { mapState, mapActions, mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import _ from "lodash";

function initSaved() {
  return false;
}

export default {
  components: { RushAcademyTutorialProgress, RushAcademyTutorialVideo },
  data() {
    return {
      currentComponent: "RushAcademyTutorialVideo",
      title: 'Get Started',
      paragraph: 'Get started with RUSH eStore! Watch this series of quick and easy self-help tutorials to kick-start your online store and do more than just selling. Find the answers to your basic how-to questions- from setting up your eStore to scaling your business.',
      currentVideoDetail: null,
      isSaved: initSaved(),
      courseUpdate: null
    }
  },
  computed: {
    ...mapState("auth", {
      enabledTopUps: state => state.enabledTopUps
    }),
    ...mapGetters({
      errors: "rushAcademy/errors"
    }),
    ...mapFields("rushAcademy", ["rush_academy"]),
    computedCourses: {
      get() {
        return this.rush_academy
          ? this.rush_academy.tutorial_progress
          : [];
      },
      set(courses) {
        return courses;
      }
    }
  },
  async created() {
    if (this.enabledTopUps.indexOf('estore') === -1) this.$router.push({ path: '/' });
    else {
      await this.getRushAcademy();
      if (_.isEmpty(this.errors)) this.currentVideoDetail = this.computedCourses[0];
      const videoId = this.$route.params.video;
      if (videoId) this.currentVideoDetail = this.computedCourses.find(vid => getIdFromUrl(vid.url) === videoId);
      else {
        this.$router.push({ name: "RushAcademy", params: { video: getIdFromUrl(this.computedCourses[0].url) } })
      }
    }
  },
  methods: {
    ...mapActions({
      getRushAcademy: 'rushAcademy/getRushAcademy'
    }),
    handleChangeVideo(video) {
      const current_video = this.computedCourses.find(vid => vid.is_playing === true);
      if (current_video && getIdFromUrl(current_video.url) === getIdFromUrl(video.url)) {
        current_video.is_playing = false;
        this.$root.$emit('pause-video');
      } else {
        this.computedCourses.map(vid => vid.is_playing = false);
        this.currentVideoDetail = video;
        setTimeout(() => {
          if (video.status < 3) this.$root.$emit('play-video', video.current_time);
          else this.$root.$emit('play-video', 0);
        }, 300);
      }
    },
    handlePlayingVideo(value) {
      if (value) {
        this.isSaved = false;
        this.courseUpdate = setInterval(() => {
          this.computedCourses.find(vid => vid.url === this.currentVideoDetail.url).is_playing = value;
        }, 100);
      } else {
        clearInterval(this.courseUpdate);
      }
    },
    handleResetPlayStatus(videoId) {
      const currentVideo = this.computedCourses.find(course => getIdFromUrl(course.url) === videoId);
      currentVideo.is_playing = false;
    },
    handleVideoEnded(videoId) {
      clearInterval(this.courseUpdate);
      const endedVideo = this.computedCourses.find(course => getIdFromUrl(course.url) === videoId);

      endedVideo.is_playing = false;
      endedVideo.status = 3;
    },
    async setPlayingProgress(data) {
      const videoId = await getIdFromUrl(this.currentVideoDetail.url);
      const convertSecondsToTimeFormat = (seconds) => {
        return this.$moment().startOf('day').seconds(seconds).format("HH:mm:ss");
      };
      this.computedCourses.find(video => getIdFromUrl(video.url) === videoId).current_time =convertSecondsToTimeFormat(data.current_time);
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@500;700&display=swap');
* {
  font-family: MainFontRegular, sans-serif;
}
h4 {
  font-size: 24px;
  color: #2F3941;
}
p {
  font-size: 14px;
  color: #68737D;
}
</style>